<template>
  <div
    :id="`dashboard-vendor-ass-card`"
    :class="[
      'tw-bg-[#FCFCFC] tw-flex tw-flex-col tw-justify-between tw-p-[20px]  dashboard-vendor-ass-card',
      classStyleContent,
    ]"
  >
    <div class="tw-flex tw-flex-row tw-gap-[20px] tw-items-center">
      <div class="tw-flex tw-flex-col tw-flex-1">
        <div class="tw-mb-[13px] tw-flex tw-items-center">
          <p class="card-title">
            {{ data.providerName }}
          </p>
          <div v-if="checkStatusId()" class="vendor-ass-card-status-tag">
            <span>{{
              getComponentUiText("app-dashboard-vendor-assessment-card-tag-1")
            }}</span>
          </div>
        </div>

        <div
          class="tw-flex tw-justify-between tw-items-center tw-mb-[6px] tw-w-full"
        >
          <span class="card-field">
            {{
              getComponentUiText(
                "app-dashboard-vendor-assessment-card-assessments-1",
              )
            }}
          </span>
          <span class="tw-text-[#B7B7B7] tw-text-[13px] tw-font-[500]">{{
            handleCountAssessmentCompleted()
          }}</span>
        </div>

        <div class="tw-flex tw-justify-between tw-items-center tw-w-full">
          <span class="card-field">
            {{
              getComponentUiText(
                "app-dashboard-vendor-assessment-card-last-assessment-1",
              )
            }}
          </span>
          <span
            class="tw-text-[#B7B7B7] tw-text-[13px] tw-font-[400] tw-not-italic tw-leading-[130%]"
            >{{
              dayjs(data.dateUpdated ?? data.dateAdded).format("DD MMM YYYY")
            }}</span
          >
        </div>
      </div>
      <div class="vendor-ass-chart tw-h-[72px] tw-w-[72px]">
        <apexchart
          class="score-chart-short"
          type="radialBar"
          width="160"
          :options="optionsCurrent"
          :series="[percentFormat]"
        ></apexchart>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { IChecklistRequested } from "@/interfaces/vendor";
import { checklistRequestedStatusId } from "@/utils/constants";
import { getComponentUiText } from "@/utils/utilities";
import dayjs from "dayjs";
import { PropType, computed } from "vue";

const props = defineProps({
  classStyleContent: {
    type: String,
    default: "",
  },
  data: { type: Object as PropType<IChecklistRequested>, required: true },
});
const isLoading = computed(() => {
  return !props.data.checklistRequestedId;
});

const percentFormat = Number((props.data.scorePcnt * 100).toFixed(0));

const convertColor = () => {
  if (percentFormat >= 75) return "#01893D";
  if (percentFormat < 75 && percentFormat >= 50) return "#48A0FF";
  if (percentFormat >= 40 && percentFormat < 50) return "#FE9A05";
  if (percentFormat < 40) return "#F7553C";
};
const optionsCurrent = computed(() => ({
  colors: [convertColor()],
  chart: {
    height: 72,
    type: "radialBar",
  },
  plotOptions: {
    radialBar: {
      dataLabels: {
        name: {
          show: false,
        },
        value: {
          show: true,
          color: convertColor(),
          fontSize: "13px",
          fontWeight: 600,
          fontFamily: "Poppins",
          offsetY: 5,
          offsetX: 3,
          formatter: () => `${percentFormat}%`,
        },
      },
    },
  },
  stroke: {
    show: true,
    lineCap: "round",
  },
  fill: {
    opacity: 1,
  },
  labels: ["current"],
}));

const checkStatusId = () => {
  if (
    props.data.statusId === checklistRequestedStatusId.created ||
    props.data.statusId === checklistRequestedStatusId.inProgress ||
    props.data.statusId === checklistRequestedStatusId.waiting ||
    props.data.statusId === checklistRequestedStatusId.submitted
  )
    return true;
};

const handleCountAssessmentCompleted = () => {
  const checklistRequestedCompleted =
    props.data.checklistRequestedHistory?.filter(
      (item) => item.statusId === checklistRequestedStatusId.completed,
    );
  return checklistRequestedCompleted?.length;
};
</script>
<style scoped lang="scss">
.dashboard-vendor-ass-card {
  border-radius: 6px;
  border: 1px solid #eff0f1;
  background: #ffffff;
  min-height: 112px;
}
.card-title {
  color: #211f58;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 130%;
  padding-right: 8px;
}
.card-field {
  color: #211f58;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%;
}
.vendor-ass-chart {
  display: flex;
  align-items: center;
  justify-content: center;
}
.score-chart-short {
  position: absolute;
  &:deep(g[class*="apexcharts-radial-series"]) {
    & > path {
      filter: unset !important;
      stroke-width: 8px !important;
    }
  }

  &:deep(g[class*="apexcharts-radialbar-track"]) {
    & > path {
      filter: unset !important;
      stroke-width: 8px !important;
    }
  }
}
.vendor-ass-card-status-tag {
  background: linear-gradient(
      0deg,
      rgba(72, 160, 255, 0.15) 0%,
      rgba(72, 160, 255, 0.15) 100%
    ),
    #fff;
  color: #387dff;
  font-weight: 500;
  font-size: 11px;
  padding-top: 3px;
  padding-bottom: 3px;
  padding-left: 5px;
  padding-right: 5px;
  border-radius: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
